import dayjs from "dayjs"
export const sortUserApplications = (all: any[])=>{
    const sorted = [...all].sort((a, b) => {
      if (a.taskId !== b.taskId) {
        return a.taskId - b.taskId;
      }
      return dayjs(b.applicationDate).diff(dayjs(a.applicationDate));
    });
    return sorted
}